/**
 * LiveTicketHeader — KPI stat bar for live ticket monitoring.
 */
import React from 'react';
import { fmt$ } from '../../../../utils/formatUtils';
import { minutesAgo } from '../../squareDashboardUtils';

export default function LiveTicketHeader({ openCount, staleCount, staleMinutes, ticketCount, revenue, rushActive, alertThreshold, lastTicketPoll }) {
  return (
    <div className={`ai__ticket-header ${rushActive ? 'ai__ticket-header--rush' : openCount >= alertThreshold ? 'ai__ticket-header--alert' : ''}`}>
      <div className="ai__ticket-stat">
        <span className="ai__ticket-stat-val">{openCount}</span>
        <span className="ai__ticket-stat-label">Open Tickets</span>
      </div>
      <div className="ai__ticket-stat">
        <span className="ai__ticket-stat-val">{staleCount}</span>
        <span className="ai__ticket-stat-label">Stale ({staleMinutes}+ min)</span>
      </div>
      <div className="ai__ticket-stat">
        <span className="ai__ticket-stat-val">{ticketCount}</span>
        <span className="ai__ticket-stat-label">Total Today</span>
      </div>
      <div className="ai__ticket-stat">
        <span className="ai__ticket-stat-val">{fmt$(revenue)}</span>
        <span className="ai__ticket-stat-label">Revenue Today</span>
      </div>
      <div className="ai__ticket-stat">
        <span className="ai__ticket-stat-val">{ticketCount > 0 ? fmt$(revenue / ticketCount) : '—'}</span>
        <span className="ai__ticket-stat-label">Avg Ticket</span>
      </div>
      <div className="ai__ticket-status">
        {rushActive
          ? <span className="ai__status-badge ai__status-badge--rush">🔥 RUSH MODE</span>
          : openCount >= alertThreshold
          ? <span className="ai__status-badge ai__status-badge--alert">⚠️ HIGH VOLUME</span>
          : <span className="ai__status-badge ai__status-badge--ok">✅ Normal</span>
        }
        <span className="ai__poll-time">
          {lastTicketPoll ? `Polled ${minutesAgo(lastTicketPoll)}m ago` : 'Polling…'}
        </span>
      </div>
    </div>
  );
}
